import {
  FETCH_PRINTERS,
  DELETE_PRINTER,
  UPDATE_PRINTER,
  CREATE_PRINTER,
  SET_PRINTERS_FILTER,
} from './actionTypes'
import api from 'utils/api'

export const fetchPrinters = (currentVenueId, config) => (dispatch) =>
  api
    .fetchPrinters(currentVenueId, config)
    .then(({ data }) => dispatch(fetchPrintersAction(data)))

export const deletePrinter = (uuid, config) => (dispatch) =>
  api
    .deletePrinter(uuid, config)
    .then(({ data }) => dispatch(deletePrinterAction(data)))

export const updatePrinter = (payload, config) => (dispatch) =>
  api
    .updatePrinter(payload, config)
    .then(({ data }) => dispatch(updatePrinterAction(data)))

export const createPrinter = (payload, config) => (dispatch) =>
  api
    .createPrinter(payload, config)
    .then(({ data }) => dispatch(createPrinterAction(data)))

export const fetchPrintersAction = (printers) => ({
  type: FETCH_PRINTERS,
  payload: printers,
})

export const deletePrinterAction = (printer) => ({
  type: DELETE_PRINTER,
  payload: printer,
})

export const updatePrinterAction = (printer) => ({
  type: UPDATE_PRINTER,
  payload: printer,
})

export const createPrinterAction = (printer) => ({
  type: CREATE_PRINTER,
  payload: printer,
})

export const setPrinterFilter = (payload) => ({
  type: SET_PRINTERS_FILTER,
  payload,
})
